import theme from 'styles/theme';

export const pillFieldSx = {
  '& .MuiInputBase-root': {
    background: '#fff',
    borderRadius: '4px',
    padding: '0 20px',
  },
  '& .MuiInputBase-input': {
    fontSize: '16px',
    fontWeight: 400,
    height: '50px',
    padding: 0,
    border: 'none',
  },
  '& .MuiInput-underline:before, & .MuiInput-underline:after': {
    display: 'none',
  },
  '& .MuiInputBase-root.Mui-error': {
    border: `1px solid ${theme.palette.danger.main}`,
  },
};
